import React from 'react';
import { ExcelTableCellProps } from '../../TableCell';
import { observer } from 'mobx-react';
import { WeaCheckbox } from 'ecCom';
import { getDomIdByFieldKey } from '../../../../util/typeUtil';

@observer
export default class CheckboxElement extends React.Component<ExcelTableCellProps, any>{
    componentDidMount(){
        const { cell, form } = this.props;
        const path = cell.getPath();
        const bindObj = form.$(path);
        if (!bindObj.values()) {
            bindObj.onChange('0');
        }
    }
    componentWillReceiveProps() {
        const { cell, form } = this.props;
        const path = cell.getPath();
        const bindObj = form.$(path);
        if (!bindObj.values()) {
            bindObj.onChange('0');
        }
    }
    render() {
        const { cell, form, card, className, excel } = this.props;
        const path = cell.getPath();
        const bindObj = form.$(path);
        const {quickEditStore,getDetailFormValues} = card;
        const fieldName = getDomIdByFieldKey(bindObj.path);
        const { viewAttr: _viewAttr, isEdit, isMandatory } = bindObj.bind();

        let viewAttr = _viewAttr ? _viewAttr : (isMandatory ? 3 : (isEdit ? 2 : 1));
        if(excel.detailProps&&excel.detailProps.hasOwnProperty("isEdit")&&card.params.type == '2'){
            //如果明细表字段，设置了不可编辑已有明细,则已有明细不可编辑，但新增的明细可以编辑
            if(getDetailFormValues(form).dtl_id&&!excel.detailProps["isEdit"]){
                viewAttr = 1;
            }
        }
        let canQuickedit = bindObj.isquickedit && viewAttr == '1';
        //新增 显示模板的快编模式下 编辑模板中是否允许修改已有明细的判断
        if (canQuickedit && excel.detailProps && !excel.detailProps["isEdit"]) {
            canQuickedit = false;
        }
		let isDisplay = '';
        if(!canQuickedit){
            isDisplay = 'none';
        }
        return (
            <div className={`${canQuickedit ? 'cube-card-editformitem ':'cube-card-editformitem2'} fieldValue ${className}`} data-fieldattr={viewAttr} data-fieldmark={fieldName} 
                {...cell.cellProps}
                onClick={() => { canQuickedit && quickEditStore.lockEditFormItem(fieldName); }}
            >
                <WeaCheckbox ecId={`${this && this.props && this.props.ecId || ''}_WeaCheckbox@p5ay4m`}
                    {...bindObj.bind()}
                    viewAttr={viewAttr}
                    fieldName={fieldName} 
                />
                <span className="editicon" style={{display:isDisplay}}><i className="icon-coms-edit" ></i></span>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/cell-field/checkbox-element/index.tsx